import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import Axios from "@/lib/axios-instance";
import useGlobalLoading from "@/store/global-loading";
import useOnboardingData from "@/store/onboarding-data";

export const checkUser = async () => {
    try {
        const response = await Axios.get(`/users/check-user`);
        return response.data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.response) {
            return error?.response?.data;
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useCheckUser = () => {
    const { setIsInitialized, setIsStep1Complete, setIsStep2Complete, setIsStep3Complete, setStoreData, setUserData } = useOnboardingData();

    const { setIsLoading } = useGlobalLoading();

    const user = useQuery({ queryKey: ["check_user"], queryFn: checkUser });

    useEffect(() => {
        if (user.isLoading) {
            setIsLoading(true);
        }
        if (!user.isLoading || user.isFetched) {
            setIsLoading(false);
        }
        if (!user.isError && user.isFetched && !user.isLoading) {
            if (user?.data?.meta?.error && user?.data?.meta?.code === 404 && user?.data?.meta?.message === "Store and User not found") {
                setIsStep1Complete(false);
                setIsStep2Complete(false);
                setIsStep3Complete(false);
                setIsInitialized(false);
                setStoreData({});
                setUserData({});
            }

            if (user?.data?.meta?.error && user?.data?.meta?.code === 403 && user?.data?.meta?.message === "Store found but User not found") {
                setIsStep1Complete(true);
                setIsStep2Complete(false);
                setIsStep3Complete(false);
                setIsInitialized(false);
                setStoreData(user?.data?.data);
                setUserData({});
            }

            if (!user?.data?.meta?.error && user?.data?.meta?.code === 200 && user?.data?.meta?.message === "Store and User found") {
                setIsStep1Complete(true);
                setIsStep2Complete(true);
                setIsStep3Complete(user?.data?.data?.user?.is_paid);
                setIsInitialized(user?.data?.data?.user?.is_initialized);
                setStoreData(user?.data?.data?.store);
                setUserData(user?.data?.data?.user);
            }
        }

        return () => setIsLoading(false);
    }, [
        setIsLoading,
        user?.data,
        user.isError,
        user.isFetched,
        user.isLoading,
        setIsInitialized,
        setIsStep1Complete,
        setIsStep2Complete,
        setIsStep3Complete,
        setStoreData,
        setUserData,
        user?.data?.data?.store,
        user?.data?.data?.user,
        user?.data?.meta?.code,
        user?.data?.meta?.error,
        user?.data?.meta?.message,
    ]);

    return user;
};
